import type {
  ProfileAcquirerCreateRequest,
  ProfileAcquirerResponse,
  ProfileAcquirerUpdateRequest,
} from '../types';
import type { RequestFn } from '../client';

export class ProfileAcquirers {
  constructor(private readonly request: RequestFn) {}

  async create(params: ProfileAcquirerCreateRequest): Promise<ProfileAcquirerResponse> {
    return this.request('POST', '/profile-acquirer', { body: params });
  }

  async update(
    profileId: string,
    profileAcquirerId: string,
    params: ProfileAcquirerUpdateRequest,
  ): Promise<ProfileAcquirerResponse> {
    return this.request(
      'POST',
      `/profile-acquirer/${encodeURIComponent(profileId)}/${encodeURIComponent(profileAcquirerId)}`,
      {
        body: params,
      },
    );
  }
}
